import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoaderAction } from '../actions/loaderActions';
import { IAppStore } from '../types/appStore';

const useLoaderStore = () => {
  const dispatch = useDispatch();

  const loader = useSelector((store: IAppStore) => store.loader);

  const showLoader = React.useCallback(
    (payload: string = '') => dispatch(setLoaderAction({ showing: true, message: payload })),
    [dispatch]
  );

  const hideLoader = React.useCallback(
    () => dispatch(setLoaderAction({ showing: false, message: '' })),
    [dispatch]
  );

  return {
    loader,
    showLoader,
    hideLoader,
  };
};

export default useLoaderStore;
